import React from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";

import { FormGroup } from "../../../common-components";
import { clearRegistrationBackendError } from "../../data/actions";

const LastNameField = (props) => {
  const dispatch = useDispatch();

  const { handleErrorChange } = props;

  const handleOnBlur = (e) => {
    dispatch(clearRegistrationBackendError("last_name"));
  };

  const handleOnFocus = () => {
    handleErrorChange("last_name", "");
    dispatch(clearRegistrationBackendError("last_name"));
  };

  return (
    <FormGroup
      {...props}
      handleBlur={handleOnBlur}
      handleFocus={handleOnFocus}
    />
  );
};

LastNameField.defaultProps = {
  errorMessage: "",
};

LastNameField.propTypes = {
  errorMessage: PropTypes.string,
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleErrorChange: PropTypes.func.isRequired,
};

export default LastNameField;
